import React from "react";
import AddProjectStore from "../../../../store/AddProjectStore";
import googleImg from "../../../Assets/google-analytics/google.png";
import { useNavigate } from "react-router-dom";
import Modal from "@semcore/modal";

const AddGoogleAccount = () => {
  const navigate = useNavigate();
  const { modal_visible, setModalVisibility } = AddProjectStore(
    (state) => state
  );

  const handleGoogleConnect = () => {
    navigate("/google-data");
    setModalVisibility(false);
  };

  const handleClose = () => {
    setModalVisibility(false);
  };

  return (
    <>
      <Modal
        visible={modal_visible}
        onClose={handleClose}
        w={"90%"}
        p={"30px"}
        wMax={"700px"}
      >
        <div className="view-google-data d-flex flex-column justify-content-center align-items-center overflow-x-auto">
          <div className="text-start">
            <p className="heading-large font-light-bold">
              {" "}
              Get Valuable SEO Insights by RanksPro-Google Integration
            </p>
            <p className="mb-0">
              Once you connect your website with Google Search Console and
              Google Analytics, RanksPro will seamlessly retrieve and analyze
              your performance data. Using this data, RanksPro delivers powerful
              visual and graphical insights—clearly segmented between GSC and
              GA—to help you understand your website’s organic traffic trends,
              user behavior, and search visibility. These insights will be
              fueled with real-time, actionable optimization suggestions,
              empowering you to make data-driven decisions and consistently
              improve your website’s SEO performance.
            </p>
          </div>
          <div className="analy-gol mt-3 d-flex justify-content-center">
            <button
              className="google-login-btn w-100 px-3"
              title="Connect with Google"
              onClick={handleGoogleConnect}
            >
              <img
                src={googleImg}
                alt=""
                className=""
                style={{
                  width: "18px",
                  height: "18px",
                  marginRight: "10px",
                }}
              />
              Connect with Google
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AddGoogleAccount;
